import { render, staticRenderFns } from "./DownloadPost.vue?vue&type=template&id=25c03997&scoped=true&"
import script from "./DownloadPost.vue?vue&type=script&lang=js&"
export * from "./DownloadPost.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPost.vue?vue&type=style&index=0&id=25c03997&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c03997",
  null
  
)

export default component.exports